import {
    apiRegister
} from '../../common/api'

import {
    isPlain
} from '../../utils/base'
import { ERR_REP_MY_INFO, ERR_REP_NOT_LOGIN } from '../../const/index'
import { KAccount } from '../../models/k-user'

let loadCount = 0
const myInfo = apiRegister('my-info', {
    protoId: 25,
    path: '/user/myinfo/',
    formatQuery(query) {
        return {
            ...query,
            time: ++loadCount
        }
    },
    checkResult (R) {
        if (!isPlain(R.uinfo)) {
            return ERR_REP_MY_INFO // 数据格式非法
        }
        return 0
    },
    formatResult (R) {
        return KAccount(R.uinfo)
    }
})

export async function accountLoad (query, opts) {
    try {
        const r = await myInfo.send(query, opts)
        return r
    } catch(err){
        if (err.code === ERR_REP_NOT_LOGIN) { // 未登录
            myInfo.clear()
            return KAccount({
                uid: 0,
                nick: ''
            })
        } else {
            throw err
        }
        
    }    
}
// export async function accountLoad (query, opts) {
//     return myInfo.send(query, opts).catch(err => {
//         if (err.code === ERR_REP_NOT_LOGIN) { // 未登录
//             myInfo.clear()
//             return KAccount({
//                 uid: 0,
//                 nick: ''
//             })
//         }
//         throw err
//     })
// }
